module.exports = __webpack_public_path__ + "static/img/ninelines_th.9ca155a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/ninelines_th.png
// module id = 0zQB
// module chunks = 1